import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { mapState } from 'vuex';
import request from '@/utils/request';
import { cmsContent } from '@/api';
export default {
  data: function data() {
    return {
      content: '',
      loading: false
    };
  },
  computed: {
    // ...mapState(['articleUrl'])
  },
  methods: {
    queryData: function queryData(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return request.get(cmsContent, {
                params: {
                  id: id
                }
              });
            case 3:
              res = _context.sent;
              _this.loading = false;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              _this.content = res.obj.content.replace(/<a/g, '<a target=_blank');
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    var id = this.$route.query.id;
    this.queryData(id);
  }
};